import React from 'react';
import img from '../../../assets/icons/payment-logos/yandex-money.svg'
const YandexMoney = () => {
  return (
    <img src={img} alt="/" />
  );
}

export default YandexMoney;
